<template lang="pug">
    input-box-field.datetime-field(v-bind="$attrs" ref="inputbox")
</template>

<script>
import flatpickr from 'flatpickr'
import 'flatpickr/dist/flatpickr.css'

export default {
    name: 'datetime-field',

    props: {
        value: {
            required: true,
            validator: () => true,
        },
        minDate: {
            type: [String, Date],
        },
    },

    data() {
        return {
            picker: null,
            wasOpen: false,
        }
    },

    computed: {
        model: {
            get() {
                return this.value
            },
            set(val) {
                this.$emit('input', val)
            },
        },

        fieldEl() {
            return this.$refs.inputbox.fieldEl
        },
    },

    watch: {
        model(v) {
            this.picker.setDate(v)
        },
        minDate(v) {
            this.picker.set('minDate', v)
        },
    },

    mounted() {
        this.picker = flatpickr(this.fieldEl, {
            enableTime: true,
            monthSelectorType: 'static',
            dateFormat: "Z",
            altInput: true,
            altFormat: "M j Y, h:i K",
            defaultDate: this.model,
            minDate: this.minDate,
            position: 'below right',
            locale: {
                weekdays: {
                    shorthand: ['S', 'M', 'T', 'W', 'T', 'F', 'S'],
                    longhand: ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'],
                },
            },

            onChange: (selectedDates, dateStr) => {
                this.model = dateStr
            },
            onOpen: () => {
                if (!this.wasOpen) {
                    this.wasOpen = true
                    this.picker.close()
                    this.picker.open()
                }
            },
        })

        this.picker.calendarContainer.classList.add('datetime-field-picker')
    },

    beforeDestroy() {
        this.picker.destroy()
    },
}
</script>